import React from 'react';
import { FormField as FormFieldType, FormData, FormErrors } from '../../../../../types/ContactForm';

interface NumberInputFieldProps {
    field: FormFieldType;
    formData: FormData;
    errors: FormErrors;
    inputCssClass?: string;
    onInputChange: (name: string, value: any) => void;
    onFieldFocus: (fieldName: string) => void;
}

export const NumberInputField: React.FC<NumberInputFieldProps> = ({
    field,
    formData,
    errors,
    inputCssClass,
    onInputChange,
    onFieldFocus
}) => {
    const handleInputChange = (value: any) => {
        onInputChange(field.name, value);
        onFieldFocus(field.name);
    };

    const getInputClassName = (baseClass: string) => {
        return `${baseClass} ${inputCssClass || ''}`.trim();
    };

    return (
        <div className={`col-12 col-md-${field.width || 12}`}>
            <div
                className={`form-group ${field.required ? 'required' : ''} ${errors[field.name] ? 'has-error' : ''}`}>
                <label htmlFor={`field-${field.id}`} className="control-label">
                    {field.label}
                </label>
                <div className={field.showStepper ? "input-group" : ""}>
                    {field.showStepper && (
                        <div className="input-group-prepend">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => {
                                    let currentValueStr = formData[field.name] || '0';
                                    if (field.useCommaFormat) {
                                        currentValueStr = currentValueStr.replace(',', '.');
                                    }
                                    let currentValue = parseFloat(currentValueStr);
                                    if (isNaN(currentValue)) currentValue = 0;

                                    const newValue = currentValue - 0.5;
                                    let valueToSet = newValue.toString();

                                    if (field.useCommaFormat) {
                                        valueToSet = newValue.toString().replace('.', ',');
                                    }

                                    handleInputChange(valueToSet);
                                }}
                            >
                                <span className="fas fa-minus"></span>
                            </button>
                        </div>
                    )}

                    <input
                        type={field.useCommaFormat ? "text" : "number"}
                        id={`field-${field.id}`}
                        name={field.name}
                        className={getInputClassName('form-control')}
                        placeholder={field.placeholder || ""}
                        value={formData[field.name] || ''}
                        onChange={(e) => {
                            let value = e.target.value;
                            handleInputChange(value);
                        }}
                        onBlur={(e) => {
                            if (field.useCommaFormat && e.target.value) {
                                let cleanValue = e.target.value.replace(',', '.');
                                const numValue = parseFloat(cleanValue);
                                if (!isNaN(numValue)) {
                                    const formatted = numValue.toString().replace('.', ',');
                                    handleInputChange(formatted);
                                }
                            }
                        }}
                        onFocus={(e) => {
                            if (field.useCommaFormat && e.target.value) {
                                const cleanValue = e.target.value.replace(',', '.');
                                const numValue = parseFloat(cleanValue);
                                if (!isNaN(numValue)) {
                                    e.target.value = numValue.toString();
                                }
                            }
                        }}
                        onKeyDown={(e) => {
                            if (field.useCommaFormat && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
                                e.preventDefault();

                                let currentValueStr = formData[field.name] || '0';
                                currentValueStr = currentValueStr.replace(',', '.');
                                let currentValue = parseFloat(currentValueStr);
                                if (isNaN(currentValue)) currentValue = 0;

                                const newValue = e.key === 'ArrowUp' ? currentValue + 0.5 : currentValue - 0.5;
                                let valueToSet = newValue.toString();

                                if (field.useCommaFormat) {
                                    valueToSet = newValue.toString().replace('.', ',');
                                }

                                handleInputChange(valueToSet);
                            }
                        }}
                        required={field.required}
                        maxLength={255}
                        aria-required={field.required}
                    />

                    {field.showStepper && (
                        <div className="input-group-append">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => {
                                    let currentValueStr = formData[field.name] || '0';

                                    if (field.useCommaFormat) {
                                        currentValueStr = currentValueStr.replace(',', '.');
                                    }
                                    let currentValue = parseFloat(currentValueStr);
                                    if (isNaN(currentValue)) currentValue = 0;

                                    const newValue = currentValue + 0.5;
                                    let valueToSet = newValue.toString();

                                    if (field.useCommaFormat) {
                                        valueToSet = newValue.toString().replace('.', ',');
                                    }

                                    handleInputChange(valueToSet);
                                }}
                            >
                                <span className="fas fa-plus"></span>
                            </button>
                        </div>
                    )}
                </div>
                {errors[field.name] && (
                    <div className="form-error-msg text-danger">
                        <i className="fa fa-warning"></i> {errors[field.name]}
                    </div>
                )}
            </div>
        </div>
    );
};

